(function () {
	'use strict';

    angular.module("imApp").factory("compValidationSetService", ['$ihttp', function ($ihttp) {
		let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1394,
                    parameters: parms || {}
                });
            },
            listValidations: function (parms) {
                return $ihttp.post({
                    method: 1392,
                    parameters: parms || {}
                });
            },
            listCombinations: function (parms) {
                return $ihttp.post({
                    method: 1393,
                    parameters: parms || {}
                });
            },
            saveItems: function (lists) {
                return $ihttp.post({
                    method: 1395,
                    parameters: lists
                });
            }
		};

		return service;
	}]);
})();
